import { getAPI } from "@/axios-api";

export async function getCampaigns() {
  try {
    const response = await getAPI.get('/micro_learning/campaigns/')
    if (response.status == 200) {
        return response.data?.results
    }
    return []
  } catch (error) {
    console.error('Error fetching micro-learning campaigns:', error)
    throw error
  }
}

export async function getCampaignReport(campaignId) {
  try {
    const response = await getAPI.get(`/micro_learning/campaign/report/${campaignId}`, {
        headers: {
        'Content-Type': 'multipart/form-data',
        },
        responseType: 'blob' 
        }
    )
    return response.data
  } catch (error) {
    console.error('Error fetching micro-learning campaign report:', error)
    throw error
  }
}

export async function deleteCampaign(campaignToDeleteId) {
  try {
    const response = await getAPI.delete(`/micro_learning/campaigns/${campaignToDeleteId}/`)
    if (response.status == 204) {
        return response.data
    }
  } catch (error) {
    console.error('Error deleting micro-learning campaign:', error)
    throw error
  }
}

export async function getCampaignStats() {
  try {
    const response = await getAPI.get('/micro_learning/campaigns-statistics/')
    if (response.status == 200) {
        return response.data?.data
    }
    return null
  } catch (error) {
    console.error('Error fetching micro-learning campaign stats:', error)
    throw error
  }
}

